/**
 * @Author Morsal
 */
import { CablePuzzleComponent } from "./CablePuzzleComponent";

export class CablePuzzlePageComponent extends HTMLElement {
    public connectedCallback(): void {
        this.id = "cable-puzzle-overlay"; // Zorg dat modal later goed te vinden/verwijderen is

        this.attachShadow({ mode: "open" });

        const puzzle: CablePuzzleComponent = document.createElement("cable-puzzle") as CablePuzzleComponent;

        this.shadowRoot!.innerHTML = `
        <style>
            :host {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 9999;
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        </style>
      `;
        this.shadowRoot!.appendChild(puzzle);
    }
};
